import React, { useEffect } from "react";
import "../assets/js/clientReview.js";

function AdminClient() {
    useEffect(() => {
        // Register jQuery handlers after React mounts the form elements
        if (window.initializeClientReviewHandlers) {
            window.initializeClientReviewHandlers();
        }

        // Load reviews from the backend
        if (window.loadClientReviews) {
            window.loadClientReviews();
        }

        // Clean up handlers when the component unmounts
        return () => {
            window.jQuery?.(document).off(".clientReview");
            window.jQuery?.("#addClientForm").off(".clientReview");
            window.jQuery?.("#editClientForm").off(".clientReview");
        };
    }, []);

    return (
        <div>
            <h1 className="bg-warning p-3">
                Admin Client Review
            </h1>

            <section>
                <div className="p-2 d-flex justify-content-between align-items-center">
                    <h2>All Reviews</h2>

                    <button
                        type="button"
                        id="addClient"
                        className="btn btn-primary text-white"
                        data-bs-toggle="modal"
                        data-bs-target="#clientModal"
                    >
                        <i className="fa-solid fa-plus"></i> Add
                    </button>
                </div>

                <div className="row px-lg-2">
                    <div className="col-12 overflow-auto">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Sr No.</th>
                                    <th scope="col">Image</th>
                                    <th scope="col">Company Name</th>
                                    <th scope="col">Product Name</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>

                            <tbody id="allClientsData"></tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Add Client Review Modal */}
            <div
                className="modal fade"
                id="clientModal"
                tabIndex="-1"
                aria-labelledby="clientModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content overflow-auto">
                        <div className="modal-header bg-primary text-white">
                            <h5
                                className="modal-title text-white"
                                id="clientModalLabel"
                            >
                                Add Review
                            </h5>

                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <form
                            id="addClientForm"
                            encType="multipart/form-data"
                            className="p-3"
                        >
                            <div className="modal-body">
                                <div className="row g-3">
                                    <div className="col-md-12 mb-3">
                                        <label
                                            htmlFor="companyName"
                                            className="form-label text-dark"
                                        >
                                            <b>Company Name</b>
                                        </label>

                                        <input
                                            type="text"
                                            name="companyName"
                                            id="companyName"
                                            className="form-control"
                                            required
                                            placeholder="Enter company name"
                                        />
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label
                                            htmlFor="product"
                                            className="form-label text-dark"
                                        >
                                            <b>Product</b>
                                        </label>

                                        <input
                                            type="text"
                                            name="product"
                                            id="product"
                                            className="form-control"
                                            required
                                            placeholder="Enter product"
                                        />
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label
                                            htmlFor="discription"
                                            className="form-label text-dark"
                                        >
                                            <b>Description</b>
                                        </label>

                                        <textarea
                                            className="form-control"
                                            placeholder="Description here..."
                                            name="discription"
                                            id="discription"
                                            style={{ height: "100px" }}
                                        ></textarea>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label
                                            htmlFor="image"
                                            className="form-label text-dark"
                                        >
                                            <b>Client Logo</b>
                                        </label>

                                        <input
                                            type="file"
                                            className="form-control"
                                            id="image"
                                            name="image"
                                            accept="image/*"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn fw-semibold btn-primary"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Edit Client Review Modal */}
            <div
                className="modal fade"
                id="editClientModal"
                tabIndex="-1"
                aria-labelledby="editClientModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5
                                className="modal-title"
                                id="editClientModalLabel"
                            >
                                Edit Client
                            </h5>

                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <form
                            id="editClientForm"
                            encType="multipart/form-data"
                            className="p-3"
                        >
                            <div className="modal-body">
                                <input type="hidden" id="editId" />

                                <div className="mb-3">
                                    <label
                                        htmlFor="editCompanyName"
                                        className="form-label"
                                    >
                                        <b>Company Name</b>
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="editCompanyName"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label
                                        htmlFor="editProduct"
                                        className="form-label"
                                    >
                                        <b>Product</b>
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="editProduct"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label
                                        htmlFor="editDescription"
                                        className="form-label"
                                    >
                                        <b>Description</b>
                                    </label>

                                    <textarea
                                        className="form-control"
                                        id="editDescription"
                                        style={{ height: "100px" }}
                                    ></textarea>
                                </div>

                                <div className="mb-3">
                                    <label
                                        htmlFor="editImage"
                                        className="form-label"
                                    >
                                        <b>Client Logo</b>
                                    </label>

                                    <input
                                        type="file"
                                        className="form-control"
                                        id="editImage"
                                        accept="image/*"
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            <div
                className="modal fade"
                id="successModal"
                tabIndex="-1"
                aria-labelledby="successModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow-lg">
                        <div className="modal-header bg-success text-white">
                            <h5
                                className="modal-title fw-bold"
                                id="successModalLabel"
                            >
                                <i className="bi bi-check-circle-fill me-2"></i>
                                Success
                            </h5>

                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <div className="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="text-success mb-3"
                                width="60"
                                height="60"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                                aria-hidden="true"
                            >
                                <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
                            </svg>

                            <h5
                                id="successMessage"
                                className="fw-semibold text-dark"
                            >
                                Action completed successfully!
                            </h5>
                        </div>

                        <div className="modal-footer border-0 justify-content-center">
                            <button
                                type="button"
                                className="btn btn-success px-4"
                                data-bs-dismiss="modal"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminClient;


// import React, { useEffect } from 'react';
// import '../assets/js/clientReview.js';


// function AdminClient() {
//     useEffect(() => {
//         if (window.loadClientReviews) {
//             window.loadClientReviews();
//         }
//     }, []);

//     return (
//         <div>
//             <h1 className="bg-warning p-3 ">Admin Client Review</h1>

//             <section>
//                 <div className="p-2 d-flex justify-content-between align-items-center">
//                     <h2>All Reviews</h2>
//                     <a href="#" id='addClient' class="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#clientModal">
//                         <i class="fa-solid fa-plus"></i> Add
//                     </a>
//                 </div>
//                 <div className="row px-lg-2">
//                     <div className="col-12 overflow-scroll">
//                         <table class="table table-bordered">
//                             <thead>
//                                 <tr>
//                                     <th scope="col">Sr No.</th>
//                                     <th scope="col">Image</th>
//                                     <th scope="col">Company Name</th>
//                                     <th scope="col">Product Name</th>
//                                     <th scope="col">Description</th>
//                                     <th scope="col">Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody id="allClientsData"></tbody>
//                         </table>
//                     </div>
//                 </div>
//             </section>

//             {/* Client Model */}
//             <div class="modal fade" id="clientModal" tabindex="-1" aria-labelledby="clientModalLabel" aria-hidden="true">
//                 <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
//                     <div class="modal-content overflow-scroll">

//                         <div class="modal-header bg-primary text-white">
//                             <h5 class="modal-title text-white" id="clientModalLabel">Add Review</h5>
//                             <button type="button" class="btn-close border border-0 text-white btn-close-white" data-bs-dismiss="modal"></button>
//                         </div>

//                         <form id="addClientForm" enctype="multipart/form-data" class="p-3">
//                             <div class="modal-body">
//                                 <div class="row g-3">
//                                     <div class="col-md-12 mb-3">
//                                         <label class="form-label text-dark"><b>Company Name</b></label>
//                                         <input type="text" name="companyName" id="companyName" class="form-control" required placeholder='enter company name' />
//                                     </div>
//                                     <div class="col-md-12 mb-3">
//                                         <label class="form-label text-dark"><b>Product</b></label>
//                                         <input type="text" name="product" id="product" class="form-control" required placeholder='enter product' />
//                                     </div>
//                                     <div class="col-md-12 mb-3">
//                                         <label class="form-label text-dark"><b>Description</b></label>
//                                         <textarea className="form-control" placeholder="description here..." name='discription' id='discription' style={{ height: "100px" }}></textarea>

//                                     </div>
//                                     <div class="col-md-12 mb-3">
//                                         <label class="form-label text-dark"><b>Client Logo</b></label>
//                                         <input type="file" className="form-control" id="image" name="image" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div class="modal-footer">
//                                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                                 <button type="submit" class="btn fw-semibold btn-primary">Save</button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             {/* client Model */}



//             <div class="modal fade" id="editClientModal" tabindex="-1">
//                 <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
//                     <div class="modal-content">

//                         <div class="modal-header bg-primary text-white">
//                             <h5 class="modal-title">Edit Client</h5>
//                             <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
//                         </div>

//                         <form id="editClientForm" enctype="multipart/form-data" class="p-3">
//                             <div class="modal-body">
//                                 <input type="hidden" id="editId" />

//                                 <label><b>Company Name</b></label>
//                                 <input type="text" class="form-control" id="editCompanyName" required />

//                                 <label><b>Product</b></label>
//                                 <input type="text" class="form-control" id="editProduct" required />

//                                 <label><b>Description</b></label>
//                                 <textarea class="form-control" id="editDescription" style={{ height: "100px" }}></textarea>

//                                 <label><b>Client Logo</b></label>
//                                 <input type="file" class="form-control" id="editImage" />
//                             </div>

//                             <div class="modal-footer">
//                                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                                 <button type="submit" class="btn btn-primary">Save</button>
//                             </div>
//                         </form>

//                     </div>
//                 </div>
//             </div>




//             {/* ✅ Universal Success Modal */}
//             <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
//                 <div class="modal-dialog modal-dialog-centered">
//                     <div class="modal-content border-0 shadow-lg">

//                         <div class="modal-header bg-success text-white">
//                             <h5 class="modal-title fw-bold" id="successModalLabel">
//                                 <i class="bi bi-check-circle-fill me-2"></i> Success
//                             </h5>
//                             <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
//                         </div>

//                         <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
//                             <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
//                                 <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z" />
//                             </svg>
//                             <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
//                         </div>

//                         <div class="modal-footer border-0 justify-content-center">
//                             <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
//                         </div>

//                     </div>
//                 </div>
//             </div>

//         </div>
//     );
// }

// export default AdminClient;